<div>

  <div class="login-header">
    <div class="account-box">
      <div class="account-wrapper">

        <!-- New Logo -->
        <div class="logo-wrapper">
          <img src="assets/img/IMG_20260710_164659.png" alt="Aelumni Logo" class="brand-logo" />
        </div>
        <!-- /New Logo -->

        <h2 id="login-title" class="account-title">Set Password</h2>
        <p class="account-subtitle">Create a new password for your account</p>
        <div *ngIf="errors" class="account-subtitle text-danger">{{errors}}</div>

        <!-- Account Form -->
        <form [formGroup]="form" (ngSubmit)="resetPassword()">

          <div class="form-group">
            <label>User Email</label>
            <div class="input-wrapper">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <path d="M22 6l-10 7L2 6" />
                <path d="M2 6h20v12H2z" />
              </svg>
              <input class="form-control" type="text" formControlName="email" id="email" />
            </div>
            <div *ngIf="form.get('email').invalid && (form.get('email').touched || submitted)">
              <small class="text-danger" *ngIf="form.get('email')?.errors?.['required']">
                Email is required
              </small>
              <small class="text-danger" *ngIf="form.get('email')?.errors?.['email']">
                Invalid email format
              </small>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col">
                <label>Password</label>
              </div>
            </div>
            <div class="input-wrapper">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <rect x="4" y="10" width="16" height="10" rx="2" />
                <path d="M8 10V7a4 4 0 0 1 8 0v3" />
              </svg>
              <input class="form-control" [type]="newpassword == true ? 'password' : 'text'" formControlName="password"
                id="password">
              <i class="icon toggle-icon" [ngClass]="newpassword == true ? 'pi pi-eye' : ''"
                (click)="passwordVisible()"></i>
            </div>
            <div *ngIf="form.get('password').invalid && (form.get('password').touched || submitted)">
              <small *ngIf="form.get('password').errors?.required && form.get('password').touched"
                class="text-danger">password required*</small>
              <small *ngIf="form.get('password').errors?.pattern && form.get('password').touched"
                class="text-danger">min 8 letters and 1 special(&.$.&#64;...)*</small>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col">
                <label>Confirm Password</label>
              </div>
            </div>
            <div class="input-wrapper">
              <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <rect x="4" y="10" width="16" height="10" rx="2" />
                <path d="M8 10V7a4 4 0 0 1 8 0v3" />
              </svg>
              <input class="form-control" type="password" formControlName="confirmPassword" id="confirmPassword">
            </div>
            <div *ngIf="form.get('confirmPassword').invalid && (form.get('confirmPassword').touched) || submitted">
              <small *ngIf="form.get('confirmPassword').invalid && (form.get('confirmPassword').touched)|| submitted"
                class="text-danger">confirm password required*
              </small>
            </div>
            <div *ngIf="isvalidconfirmpassword" class="text-danger">
              password not matching
            </div>
          </div>

          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">Submit</button>
          </div>
        </form>
        <!-- /Account Form -->
      </div>
    </div>
  </div>
</div>